import React, { useState, useEffect } from 'react';

import classnames from "classnames";
import {
    Button,
    ButtonGroup,
    Row,
    UncontrolledPopover,
    PopoverBody,
    Col,
    Modal,
} from "reactstrap";

function Situacoes({ value, onChange }) {

    const [situacoes] = useState([
        { id: '', text: 'Todos' },
        { id: 'com_acoes', text: 'Com Ações' },
        { id: 'vazio', text: 'Sem Ações' }
    ])


    return (
        <>
            <ButtonGroup className="btn-group-toggle mt-4 py--4" size='sm' data-toggle="buttons">
                {
                    situacoes.map((item, key) => (
                        <Button
                            className={classnames({ active: value == item.id })}
                            color="secondary"
                            onClick={() => onChange(item.id)}>
                            <input
                                autoComplete="off"
                                name="options"
                                type="radio"
                                value={value == item.id}
                            />
                            {item.text}
                        </Button>
                    ))
                }
            </ButtonGroup>
        </>
    )
}

export default Situacoes;